import { render, staticRenderFns } from "./VueButton.vue?vue&type=template&id=b4639a00&scoped=true&"
import script from "./VueButton.vue?vue&type=script&lang=js&"
export * from "./VueButton.vue?vue&type=script&lang=js&"
import style0 from "./VueButton.vue?vue&type=style&index=0&id=b4639a00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4639a00",
  null
  
)

export default component.exports